module.exports = __webpack_public_path__ + "static/media/Touranbieter.8c7d6a49.png";